import React, { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styled, { createGlobalStyle, css } from "styled-components";
import UserAPI from "../../apis/UserAPI";
import Reviewed from "./Reviewed";

const Notifications = ({ onGoToLesson = (obj) => { } }) => {
  useEffect(() => {
    let unsubscribe = UserAPI.subscribeToLastNotifications(
      (obj) => {
        if (obj.type === "REVIEW" && obj.state === "PENDING") {
          let toastId = toast(
            <Reviewed
              onClick={() => {
                onGoToLesson({
                  courseId: obj.courseId,
                  episodeId: obj.episodeId,
                  chapterId: obj.chapterId,
                  lessonId: obj.lessonId,
                });
                toast.dismiss(toastId);
              }}
            />,
            {
              position: "top-center",
              autoClose: false,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              className: "reviewed",
              onClose: () => {
                UserAPI.completeNotification(obj.id);
              },
            }
          );
        }
      },
      () => {}
    );

    return () => unsubscribe();
  }, []);
  return (
    <>
      <GlobalStyles />
      <ToastContainer newestOnTop />
    </>
  );
};

const GlobalStyles = createGlobalStyle`

  .Toastify__toast.reviewed {
    border-radius: 15px;
  }

  .Toastify__toast.reviewed > .Toastify__toast-body {
    color: black;
  }

  @media (max-width: 480px) {
    .Toastify__toast.reviewed {
      border-radius: 0px;
    }
  }

`;

export default Notifications;
